import { ProductAttributesContainer as SourceProductAttributesContainer } from 'SourceComponent/ProductAttributes/ProductAttributes.container';

/** @namespace Component/ProductAttributes/Container */
export class ProductAttributesContainer extends SourceProductAttributesContainer {

    containerProps() {
        const { 
            areDetailsLoaded, 
            product, 
            productOrVariant, 
            isProductInformation 
        } = this.props;

        return {
            isProductInformation,
            areDetailsLoaded,
            product,
            productOrVariant,
            attributesWithValues: this._getAttributesWithValues()
        };
    }
}

export default ProductAttributesContainer;
